<template>
  <div class="h-full" :class="{ select: isHandlingTestFrame }">
    <div class="w-full relative pt-2" :style="`height: calc(100% - ${testFrameHeight}px)`">
      <MonacoEditor
        id="editor"
        class="min-h-0 mr-1 h-full w-full"
        :keySubmmit="keySubmmit"
        :keyTest="keyTest"
        :shortcutKey="shortcutKey"
        :sideMenuWidth="sideMenuWidth"
        style="user-select: none"
      />
    </div>
    <div
      class="w-full z-10 absolute border-t bottom-0 flex flex-col border-gray-300 dark:border-dark-200"
      :style="`height: ${testFrameHeight}px`"
    >
      <div
        class="panel-cursor-area w-full py-1 h-2 border-b border-gray-300 hover:bg-primary dark:border-dark-200 dark:hover:bg-primary"
        :class="{
          'bg-primary ': isHandlingTestFrame
        }"
        @mousedown="mouseDownEditorBottomSlideBar()"
      />
      <TestFrame @openReviewAlertModal="openReviewAlertModal" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import TestFrame from './children/TestFrame.vue'

import { JudgeStatusType } from '@/domain/value_objects/judge/JudgeStatusType'
import MonacoEditor from '@/presentation/components/MonacoEditor/MonacoEditor.vue'
import { useEditorPageStatePresenter } from '@/presentation/composables/editor/useEditorPageStatePresenter'
import { useModalStatePresenter } from '@/presentation/composables/modal/useModalStatePresenter'
import { useReviewRequestPresenter } from '@/presentation/composables/reviewRequest/useReviewRequestPresenter'

export default defineComponent({
  components: {
    TestFrame,
    MonacoEditor
  },
  props: {
    sideMenuWidth: {
      type: Object,
      required: true
    },
    keyTest: {
      type: Function,
      required: true
    },
    keySubmmit: {
      type: Function,
      required: true
    },
    shortcutKey: {
      type: Array,
      requested: true
    }
  },
  setup(props, ctx) {
    const { testFrameHeight, mouseDownEditorBottomSlideBar, isHandlingTestFrame } = useEditorPageStatePresenter()
    const reviewRequestPresenter = useReviewRequestPresenter()
    const modalStatePresenter = useModalStatePresenter()

    const openReviewAlertModal = (judgeId: number, status: JudgeStatusType) => {
      reviewRequestPresenter.setReviewRequestData(judgeId, status)
      modalStatePresenter.setIsShowReviewAlertModal(true)
    }

    return { testFrameHeight, mouseDownEditorBottomSlideBar, isHandlingTestFrame, openReviewAlertModal }
  }
})
</script>
<style lang="postcss" scoped>
.editor-area {
  grid-area: editor;
}
.panel-cursor-area {
  cursor: row-resize;
}
</style>
